"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const SuccessSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 51.3337C15.113 51.3337 4.66669 40.8873 4.66669 28.0003C4.66669 15.1133 15.113 4.66699 28 4.66699C40.887 4.66699 51.3334 15.1133 51.3334 28.0003C51.3334 40.8873 40.887 51.3337 28 51.3337ZM25.6737 37.3337L42.1704 20.8347L38.871 17.5353L25.6737 30.735L19.0727 24.134L15.7734 27.4333L25.6737 37.3337Z" fill="currentColor" />
  </svg>

)

const SuccessIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SuccessSvg} {...props} />
);

export default SuccessIcon